export const HTML_LANG_MAP = {
  es: "es",
  "fr-FR": "fr",
  "it-IT": "it",
  "pt-BR": "pt",
  "nl-NL": "nl",
  "de-DE": "de",
  "en-GB": "en",
};
